import React, { CSSProperties } from 'react'
import styles from './LineRatio.module.css'
import { BasicStyledComponent } from 'shared-definitions/types'
import clsx from 'clsx'

interface LineRatioProps extends BasicStyledComponent {
  left: number
  right: number
  fgClassName?: string
}

const LineRatio: React.FC<LineRatioProps> = ({ fgClassName, className, left, right }) => (
  <div
    className={clsx(styles.container, className)}
    style={{ '--fraction': left / (left + right) } as CSSProperties}
  >
    <span className={clsx(styles.innerLine, fgClassName)} />
  </div>
)

export default LineRatio
